<div class="mb-2">
    <input pInputText [(ngModel)]="globalFilter" (input)="dt?.filterGlobal(globalFilter, 'contains')" placeholder="Pesquisar município" class="w-full" />
    <small class="texto-ajuda"></small>
    @if (!canEnableList()) {
        <div class="mt-1 text-color-secondary text-sm"></div>
    }
</div>

@if (canEnableList()) {
    <p-table
        #dt
        [value]="options"
        [paginator]="true"
        [rows]="10"
        [loading]="loading"
        [rowHover]="true"
        [globalFilterFields]="['label']"
        selectionMode="single"
        dataKey="id"
        [(selection)]="selectedRow"
        (onRowSelect)="onRowSelect()"
        (onRowUnselect)="onRowUnselect()"
        [style]="{ width: '100%' }"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Município</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
            <tr [pSelectableRow]="row" (dblclick)="onRowDblClick(row)">
                <td>{{ row.label }}</td>
            </tr>
        </ng-template>
    </p-table>
}

<!-- Ações internas: Cancelar / Selecionar -->
@if (showActions()) {
    <div class="flex justify-end gap-2 mt-3">
        <p-button label="Cancelar" severity="secondary" (onClick)="onCancelarClick()"></p-button>
        <p-button label="Selecionar" icon="pi pi-check" (onClick)="onSelecionarClick()" [disabled]="!selectedRow || !canEnableList()"></p-button>
    </div>
}
